import React, { useState, DragEvent } from 'react';
import { Box, Typography, Button, CircularProgress, Alert } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useAuth } from '../../../auth/auth';
import { updateWorkersTime } from '../../../api/apiCall';

const MacrailUploadPage = () => {
  const {state} = useAuth();
  const [file, setFile] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<any>(null);
  const [error, setError] = useState<any>(null);

  const handleFileChange = (e: any) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && /\.(xlsx|xls)$/i.test(selectedFile.name)) {
      setFile(selectedFile);
      setMessage(null);
      setError(null);
    } else {
      setError('Only Excel files (.xlsx, .xls) are allowed.');
    }
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const droppedFile = e.dataTransfer.files[0];

      if (/\.(xlsx|xls)$/i.test(droppedFile.name)) {
        setFile(droppedFile);
        setMessage(null);
        setError(null);
      } else {
        setError('Only Excel files (.xlsx, .xls) are allowed.');
      }

      e.dataTransfer.clearData();
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage(null)
      setError('Please select an Excel file first.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);
      setError(null);
      setMessage(null);

      const response: any = await updateWorkersTime(state.user?.token, file)
      if(response?.data?.success) {
        setMessage(response?.data.message);
        setFile(null);
      } else {
        setError(response.message)
      }
    } catch (err: any) {
      setError(err.response?.data.message || 'Failed to upload file.');
    } finally {
      setLoading(false);
      setTimeout(() => {
        setMessage(null)
      }, 5000)
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        mt: -15,
      }}
    >
      <Box
        sx={{
          bgcolor: 'white',
          p: 5,
          borderRadius: 4,
          textAlign: 'center',
          width: '400px',
          border: '1px solid #ddd',
          // backgroundColor: dragActive ? '#dddddd40' : 'white',
          transition: 'border 0.2s ease-in-out',
        }}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <Typography variant="h6" fontWeight="bold" mb={3}>
          Upload MacRail Sign In/Out Sheet
        </Typography>

        <Button
          variant="outlined"
          component="label"
          startIcon={<UploadFileIcon />}
          sx={{ mb: 3, width: '100%' }}
        >
          {file ? <div>{file.name}</div> : "Choose File"}
          <input type="file" hidden onChange={handleFileChange} accept=".xlsx, .xls" />
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleUpload}
          disabled={loading}
          style={{ boxShadow: "none", backgroundColor: "#1976d2" }}
          sx={{ width: '100%', mb: 2 }}
        >
          {loading ? <CircularProgress size={24} style={{color: 'white'}} /> : 'Upload File'}
        </Button>
        <Typography variant="body2" color="text.secondary" mb={2}>
          or drag and drop your file here
        </Typography>

        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
      </Box>
    </Box>
  );
};

export default MacrailUploadPage;
